import { FC, useContext, useEffect, useMemo } from "react"
import { EnterpriseComplianceDashboardContext } from "../contexts/EcdContext";
import { EnterpriseComplianceFiltersContext } from "../contexts/EcdFiltersContext";
import { EcdTilesEnum } from "../interfaces";
import { tileFlyoutLink } from "../flyouts/EcdDrillInConfig";
import EcdAdequacyBreakdownFlyout from "../flyouts/EcdAdequacyBreakdownFlyout";
import AdequacyBreakdownTable from "../components/AdequacyBreakdownTable";
import { FeatureFlagContext } from "@app/feature-flags/FeatureFlagContext";
import Features from "@app/feature-flags/features";
import DashboardTile from "@app/shared/qes-standards/DashboardTile";

/**
 * Notes on the Directions and Colors of Arrows
 * Overall Gaps up is red, down is blue
 * New Gaps up is red, down is blue (but doesn't currently have an arrow)
 * Closed Gaps up is blue, down is red (but doesn't currently have an arrow)
 * Gap Percentage up is red, down is blue
 * Median Gap Age up is red, down is blue
 * County/Specialty Groups is always color-neutral
 */

const AdequacyBreakdown: FC = () => {
    const filtersContext = useContext(EnterpriseComplianceFiltersContext);
    const dashboardContext = useContext(EnterpriseComplianceDashboardContext);
    const featureFlags = useContext(FeatureFlagContext).enabledFeatureFlags;
    const title = "Adequacy Breakdown";

    useEffect(() => {
        dashboardContext.updateIsTileLoadingMap(EcdTilesEnum.AdequacyBreakdown, true);
    }, []);

    useEffect(() => {
      if (!!dashboardContext.adequacyBreakdownData) {
            dashboardContext.updateIsTileLoadingMap(EcdTilesEnum.AdequacyBreakdown, false);
        }
    }, [dashboardContext.adequacyBreakdownData]);

    useEffect(() => {
        if (!!filtersContext.apiReadyFilters) {
            dashboardContext.updateIsTileLoadingMap(EcdTilesEnum.AdequacyBreakdown, true);
        }
    }, [filtersContext.apiReadyFilters]);

    const flyoutLinkTitle = useMemo(() => {
        if (!featureFlags.has(Features.ENABLE_ECD_DRILLINS) || dashboardContext.isDataEmptyMap.get(EcdTilesEnum.AdequacyBreakdown)) {
            return title;
        }

        return tileFlyoutLink(
            <EcdAdequacyBreakdownFlyout />,
            "Adequacy Breakdown Details",
            filtersContext.isDashboardLoading || dashboardContext.isTileLoadingMap.get(EcdTilesEnum.AdequacyBreakdown),
            "adequacy-breakdown__title-flyout",
            title,
        );
    }, [
        filtersContext.isDashboardLoading,
        featureFlags.has(Features.ENABLE_ECD_DRILLINS),
        dashboardContext.isDataEmptyMap.get(EcdTilesEnum.AdequacyBreakdown),
        dashboardContext.isTileLoadingMap.get(EcdTilesEnum.AdequacyBreakdown)
    ]);
    return (
        <DashboardTile
            loading={filtersContext.isDashboardLoading || dashboardContext.isTileLoadingMap.get(EcdTilesEnum.AdequacyBreakdown)}
            title={flyoutLinkTitle}
            widthClass="col-12 col-md-6 col-xl-3"
        >
          <AdequacyBreakdownTable adequacyBreakdownData={dashboardContext.adequacyBreakdownData} />
        </DashboardTile>
    )
}

export default AdequacyBreakdown;